import { styled } from 'styled-components';

export const Text = styled.small`
    font-size: 14px;
    padding-left: 10px;
    @media (min-width: 992px) {
        float: right;
        font-size: 18px;
        color: #666;
    }
`;

export const Counter = ({ votesLeft }: { votesLeft: number }) => {
    return <Text>Pozostało głosów: {votesLeft}</Text>;
};

export default Counter;
